import { lazy } from 'react';
import { Route, Navigate } from 'react-router-dom';
import { PublicLayout } from '@/layouts/PublicLayout';

const BookingsPage = lazy(() => import('@/pages/traveler/BookingsPage').then((m) => ({ default: m.BookingsPage })));
const TripDetailsPage = lazy(() =>
  import('@/pages/traveler/BookingDetailsPage').then((m) => ({ default: m.TripDetailsPage }))
);
const SettingsPage = lazy(() => import('@/pages/traveler/SettingsPage').then((m) => ({ default: m.SettingsPage })));
const WishlistPage = lazy(() => import('@/pages/traveler/WishlistPage').then((m) => ({ default: m.WishlistPage })));
const TravelerChatPage = lazy(() => import('@/pages/traveler/ChatPage').then((m) => ({ default: m.ChatPage })));

export const travelerRoutes = (
  <>
    <Route element={<PublicLayout />}>
      <Route path="/trips/bookings" element={<BookingsPage />} />
      <Route path="/trips/bookings/:bookingId" element={<TripDetailsPage />} />
      <Route path="/trips/settings" element={<SettingsPage />} />
      <Route path="/trips/wishlist" element={<WishlistPage />} />
      <Route path="/trips/messages" element={<TravelerChatPage />} />
      <Route path="/trips/messages/:supplierId" element={<TravelerChatPage />} />
    </Route>
    {/* Legacy traveler path redirect */}
    <Route path="/traveler" element={<Navigate to="/trips/bookings" replace />} />
  </>
);
